import React, { useEffect, useState } from "react";
import { slide as Menu } from "react-burger-menu";
import { useLocation } from "react-router-dom";
import { ResponsiveSidebarProps } from "./ResponsiveSidebar.props";
import { ReactComponent as MenuIcon } from "assets/icons/Menu.svg";
import "./style.scss";

const ResponsiveSidebar = React.memo<ResponsiveSidebarProps>(({ children }) => {
    const [isOpen, setIsOpen] = useState<boolean>(false);
    const { pathname } = useLocation();

    useEffect(() => {
        setIsOpen(false);
    }, [pathname]);

    return (
        <Menu
            right
            outerContainerId={"outer-container"}
            pageWrapId={"page-wrap"}
            isOpen={isOpen}
            onOpen={() => setIsOpen(true)}
            onClose={() => setIsOpen(false)}
            customBurgerIcon={<MenuIcon />}
        >
            {children}
        </Menu>
    );
});

export default ResponsiveSidebar;
